<div class="modal-header">
  <h4 class="modal-title">
    {{ pageTitle }}
  </h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <!-- *ngFor="let factory of factoryService.factory$ | async | filterBy: ['factory_name','country','factory_description']:
filter.keyword | orderBy: filter.order; let i = index" -->
  <div class="form-group m-0 p-0">
    <div class="input-group">
      <ng-select
        class="select-in"
        [items]="rfq$ | async"
        bindLabel="internal_sku"
        bindValue="internal_sku"
        [(ngModel)]="alternate_master_sku"
        [loading]="rfqLoading"
        [typeahead]="rfqInput$"
      >
        <ng-template ng-label-tmp let-item="item">
          <span *ngIf="item">
            <b *ngIf="item.internal_sku"> [{{ item.internal_sku }}] </b>
            {{ item.product_name }}
          </span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span *ngIf="item">
            <b *ngIf="item.internal_sku"> [{{ item.internal_sku }}] </b>
            {{ item.product_name }}
          </span>
        </ng-template>
      </ng-select>
      <div class="input-group-append">
        <button
          class="btn btn-outline-secondary"
          type="button"
          (click)="attachSKU()"
          >ADD</button
        >
      </div>
    </div>
  </div>
  <div class="loading" *ngIf="loading">
    <h6 class="mb-2"
      ><i class="fas fa-spinner fa-spin"></i> Saving alternate SKU, please
      wait...</h6
    >
  </div>
  <div class="alternate-skus mt-3">
    <span
      class="kt-badge kt-badge--primary kt-badge--outline kt-badge--pill"
      *ngFor="let sku of rfq.childSku; let i = index"
    >
      {{ sku.internal_sku }}
      <a
        href="javascript:;"
        class="m-2"
        (click)="detachAlternateSku(i)"
        title="Delete Alternate SKU"
      >
        <i class="fas fa-times text-danger"></i>
      </a>
    </span>
  </div>
</div>
